import { useList } from '@libs/hooks';
import { TWidgetProps } from '@libs/types';
import { fillTemplate, parseTemplates } from '@libs/utils';
import clsx from 'clsx';
import React from 'react';
import { TConsumerListData } from '../../types/data';
import { TListTemplateOption } from '../../types/options';
import { getInlineStyles } from '../../utils/styles';
import styles from './styles/styles.module.css';

type TListTemplate = {
    Package: React.ElementType;
} & TWidgetProps<TConsumerListData, TListTemplateOption>;

export const ListTemplate: React.FC<TListTemplate> = ({ widget, Package }) => {
    const { handleClick } = useList(widget);

    const data = widget.data ?? {};
    const parsedTemplates = parseTemplates(data.templates ?? []);

    if (parsedTemplates && Array.isArray(data.items) && data.items.length > 0) {
        const useHoverStateForClickableItems = widget.options?.useHoverStateForClickableItems ?? true;
        return (
            <div data-test={widget.uid} style={getInlineStyles({ margin: widget.options?.margin })}>
                {data.items
                    .filter((i) => i !== null && i !== undefined)
                    .map((item, index) => {
                        const key = item.id ?? index;
                        if (item.clickable === false) {
                            return <Package key={key} widgets={fillTemplate(item, parsedTemplates)} />;
                        } else {
                            return (
                                <div
                                    key={key}
                                    className={clsx(styles.templateListItem, useHoverStateForClickableItems && styles.hoverState)}
                                    onClick={(_e) => handleClick(widget.uid, item)}
                                >
                                    <Package widgets={fillTemplate(item, parsedTemplates)} />
                                </div>
                            );
                        }
                    })}
            </div>
        );
    }
    return null;
};
